export default "__VITE_ASSET__CYNaZ$L1__"